import { sendProductEvent } from '../features/analytics/product-events';
import { useState, useEffect } from 'react';
import { Link } from 'react-router';
import { useStudy } from '../features/study/study-context';
import { usePlatform } from '../platform/platform-context';
import { PhotoViewer } from '../components/photo-viewer';
import { productChannel } from '../platform/channel';
export function NotesPrintPage() {
  const { notes, subjects, getPhoto } = useStudy();
  const platform = usePlatform();
  const [subject, setSubject] = useState('');
  const [tag, setTag] = useState('');
  const [openOnly, setOpenOnly] = useState(true);
  const [answer, setAnswer] = useState(true);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string>();
  const selected = notes.filter(
    (note) =>
      (!subject || note.subjectId === subject) &&
      (!tag || note.tags.includes(tag)) &&
      (!openOnly || !note.masteredAt),
  );
  useEffect(() => {
    if (selected.length > 30)
      sendProductEvent(platform.analytics, 'paywall_viewed', {
        trigger: 'workbook_limit',
        productId: 'pass_season',
      });
  }, [selected.length, platform.analytics]);
  const save = async () => {
    if (busy || !selected.length) return;
    setBusy(true);
    try {
      const { notesPdf } = await import('../features/export/notes-pdf');
      const bytes = await notesPdf(selected, subjects, answer, getPhoto);
      const file = { name: 'hoedokloop-workbook.pdf', type: 'application/pdf', bytes };
      let result = await platform.share.save(file);
      if (!result.ok) result = await platform.share.share({ title: '내 오답집', files: [file] });
      setMessage(
        result.ok
          ? '오답집 PDF를 저장했어요.'
          : 'PDF를 저장하지 못했어요. 입력한 조건은 그대로예요. 다시 시도해 주세요.',
      );
    } catch {
      setMessage('오답집을 만들지 못했어요. 사진 저장 상태를 확인하고 다시 시도해 주세요.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="pn-page pn-workbook">
      <div className="pn-print-controls">
        <Link to="/notes">오답으로</Link>
        <h1>오답집 만들기</h1>
        <p>
          정식 출시 전 무료 · 무료 최근 30문항, 합격 패스 전체 제공 예정. 지금은 전체를 만들 수
          있어요.
        </p>
        <Link to="/pass?from=workbook_limit">합격 패스 안내</Link>
        <label className="pn-field">
          과목
          <select value={subject} onChange={(event) => setSubject(event.target.value)}>
            <option value="">전체</option>
            {subjects.map((item) => (
              <option value={item.id} key={item.id}>
                {item.name}
              </option>
            ))}
          </select>
        </label>
        <label className="pn-field">
          태그
          <select value={tag} onChange={(event) => setTag(event.target.value)}>
            <option value="">전체</option>
            {[...new Set(notes.flatMap((note) => note.tags))].map((item) => (
              <option key={item}>{item}</option>
            ))}
          </select>
        </label>
        <label>
          <input
            type="checkbox"
            checked={openOnly}
            onChange={(event) => setOpenOnly(event.target.checked)}
          />{' '}
          미정복만
        </label>
        <label>
          <input
            type="checkbox"
            checked={answer}
            onChange={(event) => setAnswer(event.target.checked)}
          />{' '}
          메모 포함(끄면 문제지)
        </label>
        {selected.length ? (
          <>
            <p>{selected.length}문항</p>
            <button className="pn-button" disabled={busy} onClick={() => void save()}>
              {busy ? 'PDF 만드는 중…' : 'PDF 저장·공유'}
            </button>
            {productChannel === 'web' ? (
              <button className="pn-small-button" onClick={() => window.print()}>
                브라우저 인쇄
              </button>
            ) : null}
          </>
        ) : (
          <p>조건에 맞는 오답을 하나 이상 남기면 만들 수 있어요.</p>
        )}
        {message ? <p role="status">{message}</p> : null}
        <p>
          본인이 공부할 목적으로만 사용해요. 다른 사람의 교재·기출 원문을 배포하거나 판매하지
          마세요.
        </p>
      </div>
      {selected.map((note, index) => (
        <article key={note.id} className="pn-workbook-question">
          <h2>
            {index + 1}. {subjects.find((subject) => subject.id === note.subjectId)?.name}
          </h2>
          {note.photoAssetId ? (
            <PhotoViewer assetId={note.photoAssetId} alt="오답집 문제 사진" />
          ) : null}
          <p>{note.text}</p>
          {answer ? (
            <p>{note.memo}</p>
          ) : (
            <div className="pn-answer-space" aria-label="답을 적을 빈칸" />
          )}
        </article>
      ))}
    </div>
  );
}
